export default "__VITE_ASSET__BypuvgNG__"